module.exports = __webpack_public_path__ + "static/media/fantasycoach_leaderboard_600x70@2x.f7647af6.jpg";